<template>
    <div class="ticket">
            <div class="centrado" v-if="empresa.config.logo != null">
                <img class="center" 
                    :src="empresa.config.logo"
                    alt="Logotipo">
            </div>
            <div class="centrado">{{empresa.empresa.nombre}}</div>
            <div class="centrado"><b>Nit:</b> {{empresa.empresa.nit}}</div>

            <div class="centrado"><b>Realizado Por:</b> {{datos.nombre_usuario}}</div>
            <div class="centrado"><b>Fecha:</b> {{datos.created_at}}</div>
            <div class="centrado"><b>Datos Cliente:</b></div>
            <div class="centrado">{{datos.cliente_nombre}}</div>
            <div class="centrado"><b>Nit: </b>{{datos.cliente_nit}}</div>
            <div class="centrado">{{datos.cliente_telefono}}</div>
            <div class="centrado"><b>Dirección:</b> {{datos.cliente_direccion}}, {{datos.nombre_ciudad_venta}}, {{datos.nombre_departamento_venta}}</div>
            <table>
                <thead>
                    <tr>
                        <th class="cantidad">CANT</th>
                        <th class="producto">PRODUCTO</th>
                        <th class="precio">TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productos" :key="index">
                        <td class="cantidad">{{item.cantidad}}</td>
                        <td class="producto">{{item.nombre_item}}</td>
                        <td class="precio">$ {{numberFormat(item.subtotal_items) }}</td>
                    </tr>

                     <tr>
                        <td class="cantidad"></td>
                        <td class="producto"><b>TOTAL</b></td>
                        <td class="precio"><b>{{numberFormat(datos.monto_total)}}</b></td>
                    </tr>

                </tbody>
            </table>
            <br>
            <p class="centrado">¡GRACIAS POR SU COMPRA! </p>
        </div>
        
</template>
<script>
export default {
    
    data(){
        return{
            datos: {},
            productos: [],
            id: this.$route.params.id,
            fields: [
                { key: 'codigo', label: 'Item', sortable: true},
                { key: 'nombre_item', label: 'Descripción', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'valor_real_unit', label: 'Precio', sortable: true},
                { key: 'subtotal_items', label: 'Total', sortable: true},
            ],
            empresa: '',
        }
    },
    created(){
        this.getVentaInfo();
    },
    methods:{

        async getVentaInfo(){
            let delay = time => new Promise(res=>setTimeout(res,time));
            await this.$conectar.post('punto-venta/print-venta', {id: this.id})
            .then(response =>{
                this.datos = response.data.ventaDetail;
                this.productos = response.data.ventaDetail.items;
                this.empresa = response.data.empresa;
                
            })
            .catch(e => {
                console.log(e.response);
            })
            await delay(3000);
            window.print();
            
        },
        printWindow() {
            window.print();
        }
    }
}
</script>
<style scoped>
* {
    font-size: 12px;
    font-family: 'Times New Roman';
}

td,
th,
tr,
table {
    border-top: 1px solid black;
    border-collapse: collapse;
}

td.producto,
th.producto {
    width: 75px;
    max-width: 75px;
}

td.cantidad,
th.cantidad {
    width: 40px;
    max-width: 40px;
    word-break: break-all;
}

td.precio,
th.precio {
    width: 40px;
    max-width: 40px;
    word-break: break-all;
}

.centrado {
    text-align: center;
    align-content: center;
}

.ticket {
    width: 155px;
    max-width: 155px;
}

img {
    max-width: inherit;
    width: 80%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
@media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
}


</style>